import * as React from 'react';
import { observer } from 'mobx-react';
import { ArrowRight } from 'lucide-react';
import { t } from '~/i18n';
import { useSelectedSite } from '~hooks/useSelectedSite';
import styles from './GoToDutySiteButton.module.css';

export interface GoToDutySiteButtonProps {
  siteUuid: string;
  siteName?: string;
}

/** Moves your viewing context back to the site you're on duty at, leaving you
 *  on whatever page you're already on. The open-alarm count on the duty pill
 *  goes further and lands you on that site's alarm list — this one is just
 *  navigation, which is why it lives on this side of the two axes. */
const GoToDutySiteButton: React.FC<GoToDutySiteButtonProps> = observer(function GoToDutySiteButton({
  siteUuid,
  siteName,
}) {
  const [, setSelectedSiteUuid] = useSelectedSite();

  return (
    <button type="button" className={styles.Button} onClick={() => setSelectedSiteUuid(siteUuid)}>
      <span className={styles.Label}>{t('alertMode.goToDutySite', { site: siteName ?? '' })}</span>
      <ArrowRight size={15} aria-hidden="true" />
    </button>
  );
});

export default GoToDutySiteButton;
